import React from 'react';
import { Button, ErrorOutlineIcon, Text } from '@billda/design-system';
import { useNavigate } from 'react-router-dom';
import { Routes as AppRoutes } from '../../routes';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(AppRoutes.root);
  };

  return (
    <div className="mx-auto w-full max-w-[600px] px-4">
      <div className="mb-8 mt-16">
        <div className="rounded-xl border border-border-default bg-surface-default p-12 text-center">
          <ErrorOutlineIcon
            aria-hidden="true"
            className="mb-4 size-20 text-content-error"
          />
          <Text as="h1" variant="h2" className="mb-2">
            404
          </Text>
          <Text as="h2" variant="h5" color="secondary" className="mb-2">
            Page Not Found
          </Text>
          <Text as="div" variant="body1" color="secondary" className="mb-2">
            The page you are looking for doesn&apos;t exist or has been moved.
          </Text>
          <Button variant="neutral" onClick={handleGoHome} className="mt-4">
            Go Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
